import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { Scopes, Modal } from "Services";

const Button = ({ label, working, disabled, onClick, groupLeft, groupRight, style, type, hidden, scope, modal, className, children, classKey, ...rest}) => {
    let themeClass = null;

    if (hidden || (scope && !Scopes.has(scope))) {
        return null;
    }

    switch (classKey) {
        case 'dangerButton':
            themeClass = 'bg-app-red-bright text-white hover:bg-app-red';
            break;
        case 'primaryButton':
            themeClass = 'bg-app-blue-aetna text-white hover:bg-opacity-75';
            break;
        case 'defaultButton':
        default:
            themeClass = 'bg-app-red text-white hover:bg-opacity-75';
            break;
    }

    // Default button styles
    className = `py-1 border border-transparent text-sm font-medium rounded-md shadow-sm focus:outline-none
    focus:shadow-outline-blue transition duration-200 px-3 ${className} ${themeClass}
    ${disabled || working ? "opacity-50 cursor-not-allowed" : ""}`;

    if (groupRight) {
        className += " rounded-r-none";
    }

    if (groupLeft) {
        className += " rounded-l-none";
    }

    const handleOnClick = (e) => {
        if (onClick) {
            return onClick(e);
        } else if (modal) {
            Modal.open(modal.component, {
                ...modal,
            });
        }
    };

    return (
        <button
            {...rest}
            type={type}
            className={className}
            disabled={working || disabled}
            onClick={ handleOnClick }
            style={style}
        >
            {working && (
                <FontAwesomeIcon icon={faSpinner} spin className="mr-0.5"/>
            )}
            {label || children}
        </button>
    );
};

export default Button;
